var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("tr", [
    _c("td", { staticClass: "w-full" }, [
      _vm._v(_vm._s(_vm._f("nullable")(_vm.department.name))),
    ]),
    _vm._v(" "),
    _c("td", [
      _c(
        "button",
        {
          staticClass: "edit-button",
          on: {
            click: function ($event) {
              return _vm.$emit("edit", _vm.department.id)
            },
          },
        },
        [_c("i", { staticClass: "fa fa-fw fa-pencil-square-o" })]
      ),
    ]),
    _vm._v(" "),
    _c("td", [
      _c(
        "button",
        {
          staticClass: "delete-button",
          on: {
            click: function ($event) {
              return _vm.$emit("delete", _vm.department.id)
            },
          },
        },
        [_c("i", { staticClass: "fa fa-fw fa-minus-circle" })]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }